interface StatusBadgeProps {
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled' | string
  className?: string
}

const statusConfig: Record<string, { label: string; className: string }> = {
  pending: { label: 'Pendiente', className: 'badge-warning' },
  running: { label: 'En proceso', className: 'badge-info' },
  completed: { label: 'Completado', className: 'badge-success' },
  failed: { label: 'Fallido', className: 'badge-error' },
  cancelled: { label: 'Cancelado', className: 'text-slate-500 bg-slate-100' },
  draft: { label: 'Borrador', className: 'text-slate-600 bg-slate-100' },
  review: { label: 'En Revisión', className: 'bg-violet-100 text-violet-800' },
  approved: { label: 'Aprobado', className: 'bg-sky-100 text-sky-800' },
  published: { label: 'Publicado', className: 'badge-success' },
}

export function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const config = statusConfig[status] || { label: status, className: 'badge-info' }
  
  return (
    <span className={`badge ${config.className} ${className}`}>
      {config.label}
    </span>
  )
}
